import type { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import type { Leasing } from "~/models/Leasing";
import { editRentLandExclusiveRoomUrl } from "~/utils/BukkenKanriPath";

export type PropertyBuildingOption = {
	address: string;
	amaterasPropertyId: number | null;
	enableAutoLock: "true" | "false" | null;
	enableElevator: "true" | "false" | null;
	freeParking: string | null;
	isLandExclusiveRoom: boolean;
	key: string;
	label: string;
	landExclusiveRoomId: number | null;
	name: string;
	placeKeyStoring: string | null;
	zipCode: string | null;
};

export const getLandExclusiveRoomDetailUrl = (
	building: PropertyBuildingOption | null
): string | null => {
	if (!building?.isLandExclusiveRoom || building.landExclusiveRoomId === null) {
		return null;
	}
	return editRentLandExclusiveRoomUrl(building.landExclusiveRoomId);
};

type ComboBoxOption = Exclude<
	ComponentProps<typeof SingleComboBox>["options"][number],
	{ group: string }
>;
type ComboBoxValue = ComponentProps<typeof SingleComboBox>["value"];

export const buildBuildingOption = (
	propertyOption: PropertyBuildingOption
): ComboBoxOption => ({
	description:
		propertyOption.key === "manual-input-building"
			? "Tabキー、または、クリックで新規登録"
			: propertyOption.address,
	label: propertyOption.label,
	value: propertyOption.key
});

export const buildingOptions = (
	propertyOptions: PropertyBuildingOption[]
): ComboBoxOption[] => propertyOptions.map(buildBuildingOption);

export const propertyBuildingOptionValue = (
	propertyOption: PropertyBuildingOption | null
): ComboBoxValue => {
	if (propertyOption === null) return null;
	return {
		label: propertyOption.label,
		value: propertyOption.key
	};
};

export const buildPropertyBuildingOptionsFromRoomName = (
	roomName: string
): PropertyBuildingOption[] => {
	if (roomName === "") return [];

	return [
		{
			address: "",
			amaterasPropertyId: null,
			enableAutoLock: null,
			enableElevator: null,
			freeParking: null,
			isLandExclusiveRoom: false,
			key: "manual-input-building",
			label: roomName,
			landExclusiveRoomId: null,
			name: roomName,
			placeKeyStoring: null,
			zipCode: null
		}
	];
};

export const buildPropertyBuildingOptionsFromLeasing = (
	leasing: Leasing | null
): PropertyBuildingOption | null => {
	if (!leasing?.roomName) return null;

	return {
		address: leasing.address ?? "",
		amaterasPropertyId: leasing.amaterasBuildingPropertyId,
		enableAutoLock: null,
		enableElevator: null,
		freeParking: null,
		isLandExclusiveRoom: false,
		key: `leasing-property-building-${leasing.id}`,
		label: leasing.roomName,
		landExclusiveRoomId: null,
		name: leasing.roomName,
		placeKeyStoring: null,
		zipCode: null
	};
};
